import { useCallback, useEffect, useMemo } from 'react';

import classname from '@search/classname/src';

import { useYMapPane } from '../Pane';

import './YMapClusterer.css';

const cn = classname.bind(null, 'YMapClusterer');

interface YMapPlacemarkPOIProps {
    points: [ number, number ][];
    isMobile: boolean;
}

export function YMapClusterer({
    points,
    isMobile
}: YMapPlacemarkPOIProps) {
    const {
        map,
        api: {
            Clusterer,
            Placemark,
            templateLayoutFactory,
        }
    } = useYMapPane();

    const getIconContentLayout = useCallback((modificator?: string) => templateLayoutFactory.createClass(`
        <div class='${cn('iconCluster', { modificator })}'></div>
    `), [ templateLayoutFactory ]);

    const clusterer = useMemo(() => {
        return new Clusterer({
            minClusterSize: 2,
            groupByCoordinates: false,
            clusterHideIconOnBalloonOpen: false,
            geoObjectHideIconOnBalloonOpen: false,
            clusterIconLayout: getIconContentLayout(),
            clusterIconImageSize: [ 16, 16 ],
            clusterIconContentSize: [ 16, 16 ],
            clusterIconOffset: [ -8, -8 ],
            clusterIconShape: {
                type: 'Circle',
                coordinates: [ 0, 0 ],
                // @ts-ignore
                radius: 16
            },
            openBalloonOnClick: false,
            gridSize: 32,
            zoomMargin: isMobile ? [ 75, 75, 75, 75 ] : [ 75, 75, 75, 400 ],
        });
    }, [ Clusterer, getIconContentLayout, isMobile ]);

    useEffect(() => {
        map.geoObjects.add(clusterer);

        return () => {
            // @ts-ignore
            map.geoObjects.remove(clusterer);
        };
    }, [ clusterer, map ]);

    useEffect(() => {
        const geoObjects = points.map((point) => {
            const placemark = new Placemark(
                point,
                {},
                {
                    // @ts-ignore
                    iconLayout: 'default#imageWithContent',
                    // add 'point' param for the difference when debagging
                    iconContentLayout: getIconContentLayout(),
                    iconImageSize: [ 16, 16 ],
                    iconContentSize: [ 16, 16 ],
                    iconImageOffset: [ -8, -8 ],
                    iconShape: {
                        type: 'Circle',
                        coordinates: [ 8, 8 ],
                        // @ts-ignore
                        radius: 16
                    },
                    cursor: 'pointer',
                }
            );

            placemark.events.add('click', () => {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                map.setCenter(point, 17, {
                    useMapMargin: true,
                    duration: 200 // from default YMapControlZoom
                });
            });
            return placemark;
        });

        // @ts-ignore
        clusterer.add(geoObjects);

        // @ts-ignore
        return () => clusterer.removeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ clusterer, Placemark, points, getIconContentLayout ]);

    return null;
}
